import axios from "axios";

/**
 * JawgAPIs class.
 */
export default class JawgAPIs {
    /**
     * Get position.
     *
     * @param query
     */
    public static async getPosition(query: any = null) {
        const url: string = String(process.env.REACT_APP_IKG_JAWG_ADDRESS_URL);
        let options: any = {params: query};

        return axios.get(url, options);
    }

    public static getJawgPosition = async (town: {name: string}, address: string) => {
        const query = {
            'access-token': process.env.REACT_APP_IKG_JAWG_ADDRESS_ACCESS_TOKEN,
            'country': 'FR',
            'locality': town.name,
            'address': address
        };

        const response = await JawgAPIs.getPosition(query);

        if (response && response.data && response.data.features) {
            const data: any = response.data;
            if (Array.isArray(data.features)) {
                const coordinates: any = data.features[0].geometry.coordinates;

                return [coordinates[1], coordinates[0]];
            }
        }

        return null;
    }
};
